export const serviceValues = {
  BUILD_NEW_WEBSITE: 'new',
  REVAMP_EXISTING_WEBSITE: 'revamp',
  MIGRATE_WEBSITE: 'migrate',
};

export const newWebsitePreparedContentValues = {
  YES: 'Yes',
  NO: 'No',
};

export const newWebsiteContentTypeValues = {
  LOGO: 'Logo',
  MEDIA: 'Media',
  TEXT_MATERIALS: 'Text materials',
  OLD_WEBSITE: 'Old website',
};

export const migrationPlatformValues = {
  WORD_PRESS: 'WordPress',
  WIX: 'Wix',
  SQUARESPACE: 'Squarespace',
  JOOMLA: 'Joomla',
  SHOPIFY: 'Shopify',
  YOLA_SITEBUILDER_CLASSIC: 'Yola Sitebuilder Classic',
  I_DONT_KNOW: 'I don’t know',
};

export const migrationReasonValues = {
  MISSING_SOME_FEATURES: 'It’s missing some features',
  TOO_EXPENSIVE: 'It’s too expensive',
  HARD_TO_USE: 'It’s hard to use',
  NOT_STABLE: 'It’s not stable',
  POORLY_SUPPORTED: 'It’s poorly supported or outdated',
};

export const OTHER_VALUE = 'other';
